export default "__VITE_ASSET__Cqvc_GFF__"